import { resources } from "../../../../../../core/models/resource/resources";
import { TabData } from "../types/product-card-group-modal.types";

export const wildberriesProductCardsResourceType = resources['wildberries-product-cards'];

export const tabsData: Array<TabData> = [
  {
    title: 'Синхронизированные',
    key: 'sync',
    btnKey: 'detach',
    emptyText: 'Синхронизированных продуктов пока нет'
  },
  {
    title: 'К синхронизации',
    key: 'all',
    btnKey: 'attach',
    emptyText: 'Нет доступных продуктов для синхронизации'
  }
]
